document.addEventListener('DOMContentLoaded', function() {
  initFaqSection();
  // Accordion aç/kapa
  document.querySelectorAll('.card-header').forEach(function(header) {
    header.addEventListener('click', function() {
      var collapse = header.nextElementSibling;
      var isOpen = !header.classList.contains('collapsed');
      // Tüm diğerlerini kapat
      document.querySelectorAll('.card-header').forEach(function(h) {
        h.classList.add('collapsed');
        if (h.nextElementSibling) {
          h.nextElementSibling.style.maxHeight = null;
        }
      });
      // Eğer zaten açıksa kapat, değilse aç
      if (!isOpen) {
        header.classList.remove('collapsed');
        if (collapse) {
          collapse.style.maxHeight = collapse.scrollHeight + 'px';
        }
      } else {
        header.classList.add('collapsed');
        if (collapse) {
          collapse.style.maxHeight = null;
        }
      }
    });
    // Başlangıçta hepsi kapalı olsun
    header.classList.add('collapsed');
    if (header.nextElementSibling) {
      header.nextElementSibling.style.maxHeight = null;
    }
  });
});

// Initialize when Shopify theme editor refreshes the section
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.faq-section')) {
    initFaqSection();
  }
});

function initFaqSection() {
  // Initialize FAQ items
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      
      // Close all other items
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('active');
        }
      });
      
      // Toggle current item
      item.classList.toggle('active', !isActive);
    });
  });

  // Initialize category filter
  const categoryFilter = document.getElementById('faq-category-filter');
  if (categoryFilter) {
    categoryFilter.addEventListener('change', function() {
      const selectedCategory = this.value;
      const faqItems = document.querySelectorAll('.faq-item');
      const categoryHeadings = document.querySelectorAll('.faq-category-heading');

      // Tüm başlıkları ve öğeleri gizle
      categoryHeadings.forEach(heading => {
        heading.style.display = 'none';
      });
      faqItems.forEach(item => {
        item.style.display = 'none';
      });

      if (selectedCategory === 'all') {
        // Tüm başlıkları ve öğeleri göster
        categoryHeadings.forEach(heading => {
          heading.style.display = 'block';
        });
        faqItems.forEach(item => {
          item.style.display = 'block';
        });
      } else {
        // Seçili kategoriye ait başlığı ve öğeleri göster
        const selectedHeading = document.getElementById(selectedCategory);
        if (selectedHeading) {
          selectedHeading.style.display = 'block';
        }
        faqItems.forEach(item => {
          if (item.getAttribute('data-category') === selectedCategory) {
            item.style.display = 'block';
          }
        });
      }
    });
  }
}